/**
 * Hook for managing phone number input field
 */
import { useMemo, useState } from "react";
import { useSignup as useSignupContext } from "../../SignupContext";
import { validatePhone } from "../../validation";
export function usePhoneNumber() {
    const { formValues, setFormValues } = useSignupContext();
    // Set initial touched/blurred states to true if values were loaded from sessionStorage
    // and the field has a value
    const initialTouched = formValues.loadedFromStorage && formValues.phoneNumber.length > 0;
    const initialBlurred = initialTouched;
    const [touched, setTouched] = useState(initialTouched);
    const [blurred, setBlurred] = useState(initialBlurred);
    const validation = useMemo(() => {
        // Validate using the current locale
        return validatePhone(formValues.phoneNumber);
    }, [formValues.phoneNumber, formValues.language]); // Include language for reactivity
    return useMemo(() => ({
        value: formValues.phoneNumber,
        touched,
        blurred,
        isValid: validation.isValid,
        errorMessage: validation.errorMessage,
        setValue: setFormValues.setPhoneNumber,
        setTouched,
        setBlurred,
    }), [
        formValues.phoneNumber,
        touched,
        blurred,
        validation,
        setFormValues.setPhoneNumber,
    ]);
}
